import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import logo from "@/assets/logo.png";
import CartDrawer from "@/components/CartDrawer";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs & Events" },
  { to: "/founding-hands", label: "Founding Hands" },
  { to: "/team", label: "Our Team" },
  { to: "/contact", label: "Contact" },
  { to: "/shop", label: "Shop" },
];


const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-border/50 bg-background/90 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between md:h-20">
        <Link to="/" className="flex items-center gap-3">
          <img alt="Open Hands Healing Foundation" className="h-9 w-9 rounded-full shadow-sm md:h-11 md:w-11" src="/lovable-uploads/0c192ac7-d4d8-4b34-b863-509d026f0a35-sm.png" width="44" height="44" />
          <span className="font-serif text-lg font-semibold leading-tight text-foreground md:text-xl">
            Open Hands Healing Foundation
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex">
          {links.map((l) =>
          <Link
            key={l.to}
            to={l.to}
            className={cn(
              "rounded-md px-3 py-2 text-sm font-medium transition-colors hover:text-primary",
              pathname === l.to ?
              "text-primary" :
              "text-muted-foreground"
            )}>

              {l.label}
            </Link>
          )}
          <CartDrawer />
          <Button asChild className="ml-3">
            <Link to="/donate">Donate</Link>
          </Button>
        </nav>

        {/* Mobile toggle + cart */}
        <div className="flex items-center gap-2 lg:hidden">
          <CartDrawer />
          <button
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu">

            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      {open &&
      <nav className="border-t border-border/50 bg-background px-4 pb-4 lg:hidden">
          {links.map((l) =>
        <Link
          key={l.to}
          to={l.to}
          onClick={() => setOpen(false)}
          className={cn(
            "block rounded-md px-3 py-3 text-sm font-medium transition-colors",
            pathname === l.to ?
            "text-primary" :
            "text-muted-foreground hover:text-primary"
          )}>

              {l.label}
            </Link>
        )}
          <Button asChild className="mt-2 w-full">
            <Link to="/donate" onClick={() => setOpen(false)}>
              Donate
            </Link>
          </Button>
        </nav>
      }
    </header>);

};

export default Navbar;